import { Card, Dropdown } from "react-bootstrap";
import HACCPChart from "../components/haccp-chart-2";

export default function HACCPSection({
  data,
  limit,
  onChangeLimit,
  thn,
}) {
  return (
    <Card className="h-400 shadow-sm rounded-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="fw-bold text-uppercase mb-0">
          Grafik HACCP Per Grade
        </h6>

        <Dropdown onSelect={(v) => onChangeLimit(Number(v))}>
          <Dropdown.Toggle size="sm" variant="light">
            Top {limit}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {[5, 10, 15, 20].map((v) => (
              <Dropdown.Item key={v} eventKey={v}>
                Top {v}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {data?.data?.length ? (
          <HACCPChart rekapHACCPGrade={data.data} />
        ) : (
          <div className="text-center text-muted py-4">
            📭 Data belum tersedia pada periode ini
          </div>
        )}
        <div className="d-flex justify-content-center">
          <span
            className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
            style={{ backgroundColor: '#0071CE' }}
          >
            Total Grade A
          </span>
          <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
            {data.totGradeA?.toLocaleString("id-ID")}
          </span>
          <span
            className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
            style={{ backgroundColor: '#F7941E' }}
          >
            Total Grade B
          </span>
          <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
            {data.totGradeB?.toLocaleString("id-ID")}
          </span>
          <span
            className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
            style={{ backgroundColor: '#4BA38A' }}
          >
            Total Grade C
          </span>
          <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
            {data.totGradeC?.toLocaleString("id-ID")}
          </span>
          <span
            className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
            style={{ backgroundColor: '#DC3C22' }}
          >
            Total HACCP
          </span>
          <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
            {data.totHACCP?.toLocaleString("id-ID")}
          </span>
        </div>
      </Card.Body>
    </Card>
  );
}
